import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'contracts',
    loadComponent: () => import('./consent/components/contract-list/contract-list.component').then(m => m.ContractListComponent)
  },
  {
    path: 'consent',
    loadChildren: () => import('./consent/consent.module').then(m => m.ConsentModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  }
];
